import { createAction, props } from '@ngrx/store';
import {
  ScheduleInterface,
  ScheduleOptions,
} from 'src/app/core/models/operator-schedule.model';

export const loadOperatorSchedules = createAction(
  '[OperatorSchedules] Load Operator Schedules',
  props<{ options: ScheduleOptions }>(),
);

export const loadOperatorSchedulesSuccess = createAction(
  '[OperatorSchedules] Load Operator Schedules Success',
  props<{ events: ScheduleInterface[] }>(),
);

export const loadAllAvailableVehicles = createAction(
  '[OperatorSchedules] Load All Available Vehicles',
  props<{ options: ScheduleOptions }>(),
);

export const loadAllAvailableVehiclesSuccess = createAction(
  '[OperatorSchedules] Load All Available Vehicles Success',
  props<{ vehicleIdList: number[] }>(),
);
export const loadAllAssignedVehicles = createAction(
  '[OperatorSchedules] Load All Assigned Vehicles',
  props<{ options: ScheduleOptions }>(),
);

export const loadAllAssignedVehiclesSuccess = createAction(
  '[OperatorSchedules] Load All Assigned Vehicles Success',
  props<{ vehicleIdList: number[] }>(),
);

export const addAssignedVehicle = createAction(
  '[OperatorSchedules] Add Assigned Vehicle',
  props<{ vehicleId: number }>(),
);

export const removeAssignedVehicle = createAction(
  '[OperatorSchedules] Remove Assigned Vehicle',
  props<{ vehicleId: number }>(),
);

export const removeAvailableVehicle = createAction(
  '[OperatorSchedules] Remove Available Vehicle',
  props<{ vehicleId: number }>(),
);

export const addOperatorSchedules = createAction(
  '[OperatorSchedules] Add Operator Schedules',
  props<{ event: ScheduleInterface }>(),
);

export const addOperatorSchedulesSuccess = createAction(
  '[OperatorSchedules] Add Operator Schedules Success',
  props<{ event: ScheduleInterface }>(),
);

export const updateOperatorSchedules = createAction(
  '[OperatorSchedules] Update Operator Schedules',
  props<{ event: ScheduleInterface }>(),
);
export const updateOperatorSchedulesSuccess = createAction(
  '[OperatorSchedules] Update Operator Schedules Success',
  props<{ event: ScheduleInterface }>(),
);

export const deleteOperatorSchedules = createAction(
  '[OperatorSchedules] Delete Operator Schedules',
  props<{ event: ScheduleInterface }>(),
);

export const deleteOperatorSchedulesSuccess = createAction(
  '[OperatorSchedules] Delete Operator Schedules Success',
  props<{ id: number }>(),
);

export const operatorSchedulesError = createAction(
  '[OperatorSchedules] Operator Schedules Error',
  props<{ error: any }>(),
);
export const operatorSchedulesClear = createAction(
  '[OperatorSchedules] Operator Schedules Clear',
);
